var _g, _g2, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencyAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 177,
    viewBox: "0 0 178 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_114_8837)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.9711,
    cy: 84.9712,
    r: 71.0575,
    fill: "url(#paint0_linear_114_8837)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_114_8837)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.9708,
    cy: 84.971,
    r: 56.3253,
    fill: "url(#paint1_linear_114_8837)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_114_8837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.804 85.0433C143.804 115.287 119.287 139.804 89.0434 139.804C58.7999 139.804 34.2827 115.287 34.2827 85.0433C34.2827 54.7998 58.7999 30.2826 89.0434 30.2826C119.287 30.2826 143.804 54.7998 143.804 85.0433ZM41.6279 85.0433C41.6279 111.23 62.8565 132.459 89.0434 132.459C115.23 132.459 136.459 111.23 136.459 85.0433C136.459 58.8564 115.23 37.6277 89.0434 37.6277C62.8565 37.6277 41.6279 58.8564 41.6279 85.0433Z",
    fill: "url(#paint2_angular_114_8837)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.5282 72.89C97.8363 72.89 104.571 79.6249 104.571 87.933V98.9205C104.571 99.3207 104.412 99.7046 104.129 99.9875C103.846 100.271 103.462 100.43 103.062 100.43H75.9942C75.594 100.43 75.2102 100.271 74.9272 99.9875C74.6442 99.7046 74.4852 99.3207 74.4852 98.9205V87.933C74.4852 79.6249 81.2201 72.89 89.5282 72.89ZM88.2078 64.5904H90.8486C90.9486 64.5904 91.0446 64.6301 91.1154 64.7009C91.1861 64.7716 91.2258 64.8676 91.2258 64.9676V69.4947C91.2258 69.5947 91.1861 69.6907 91.1154 69.7615C91.0446 69.8322 90.9486 69.8719 90.8486 69.8719H88.2078C88.1078 69.8719 88.0118 69.8322 87.9411 69.7615C87.8703 69.6907 87.8306 69.5947 87.8306 69.4947V64.9676C87.8306 64.8676 87.8703 64.7716 87.9411 64.7009C88.0118 64.6301 88.1078 64.5904 88.2078 64.5904ZM73.7425 70.4218C73.7775 70.3867 73.8191 70.3589 73.8649 70.3399C73.9107 70.3209 73.9598 70.3112 74.0094 70.3112C74.059 70.3112 74.1081 70.3209 74.1539 70.3399C74.1997 70.3589 74.2413 70.3867 74.2763 70.4218L77.4773 73.6228C77.548 73.6935 77.5877 73.7895 77.5877 73.8895C77.5877 73.9895 77.548 74.0854 77.4773 74.1561L75.6099 76.0235C75.5391 76.0942 75.4432 76.134 75.3432 76.134C75.2432 76.134 75.1473 76.0942 75.0765 76.0235L71.8755 72.8225C71.8048 72.7518 71.7651 72.6559 71.7651 72.5559C71.7651 72.4559 71.8048 72.3599 71.8755 72.2892L73.743 70.4218H73.7425ZM105.319 70.4218L107.186 72.2892C107.257 72.3599 107.296 72.4557 107.296 72.5556C107.296 72.6555 107.257 72.7514 107.186 72.8221L103.985 76.024C103.95 76.0591 103.908 76.0869 103.863 76.1059C103.817 76.1249 103.768 76.1347 103.718 76.1347C103.669 76.1347 103.619 76.1249 103.574 76.1059C103.528 76.0869 103.486 76.0591 103.451 76.024L101.584 74.1566C101.549 74.1216 101.521 74.08 101.502 74.0342C101.483 73.9884 101.473 73.9393 101.473 73.8897C101.473 73.8401 101.483 73.791 101.502 73.7452C101.521 73.6994 101.549 73.6578 101.584 73.6228L104.785 70.4218C104.856 70.3511 104.952 70.3114 105.052 70.3114C105.152 70.3114 105.248 70.3511 105.319 70.4218ZM74.438 103.448H104.618C105.019 103.448 105.402 103.607 105.685 103.89C105.968 104.173 106.127 104.556 106.127 104.957V106.088C106.127 106.188 106.088 106.284 106.017 106.355C105.946 106.426 105.85 106.466 105.75 106.466H73.3063C73.2062 106.466 73.1103 106.426 73.0395 106.355C72.9688 106.284 72.929 106.188 72.929 106.088V104.957C72.929 104.556 73.088 104.173 73.371 103.89C73.654 103.607 74.0378 103.448 74.438 103.448ZM81.4172 88.4989V100.43H84.4353V88.4989H81.4172Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_114_8837",
    x: 15.2818,
    y: 13.9136,
    width: 147.379,
    height: 147.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.63176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31588
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_114_8837",
    x: 30.5594,
    y: 28.6458,
    width: 116.823,
    height: 116.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.08612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_114_8837",
    x: 32.1966,
    y: 30.2826,
    width: 113.694,
    height: 113.694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.08612
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_114_8837",
    x: 0.851852,
    y: 0,
    width: 176.296,
    height: 176.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_8837",
    x1: 88.9711,
    y1: 13.9136,
    x2: 88.9711,
    y2: 156.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D96969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F86F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_114_8837",
    x1: 88.9708,
    y1: 28.6457,
    x2: 88.9708,
    y2: 141.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_114_8837",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.0434 32.9669) rotate(90) scale(106.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD0000",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_114_8837",
    x1: 89,
    y1: 0,
    x2: 89,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyAlarm);
export default __webpack_public_path__ + "static/media/emergency-alarm.e4374a008de048d4728a2ca337d7ac04.svg";
export { ForwardRef as ReactComponent };